module.exports = __webpack_public_path__ + "img/circulararw.883df605.svg";